import React from 'react';
import { NavLink } from 'react-router-dom';

class AboutCompany extends React.Component {
    render() {
        return (
            <>
                <div className="section-full p-t80 bg-white">
                    <div className="container">
                        <div className="section-content ">
                            <div className="m-service-containt text-black">
                                <div className="row">
                                    <div className="col-md-5 col-sm-12">
                                        <div className="service-about-left">
                                            <div className="mt-media">
                                                <img src={require('./../../images/s-1.png')} alt=""/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-7 col-sm-12">
                                        <div className="service-about-right m-b30">
                                            <h3 className="m-t0">We take pride in our work, delivering quality every time.</h3>
                                            <p>We take pride in every project we undertake, ensuring the highest standards of quality and precision across all CSI divisions. Our team is committed to providing accurate, reliable takeoff services that meet the unique needs of each client. By leveraging advanced tools and industry expertise, we consistently deliver results that empower contractors to succeed in every phase of their projects. From planning to completion, we are dedicated to excellence and client satisfaction.</p>
                                            <div className="call-for-quote-outer">
                                                <div className="call-quote">
                                                    <span>Email For a Quote:</span>
                                                    <h4><a href='mailto:info@qto.international' style={{ textDecoration: 'none', color: "#fff   " }}>info@qto.international</a></h4>
                                                </div>
                                                <div className="call-estimate bg-dark">
                                                <NavLink to={"/get-free-quote"} className="site-button-secondry btn-effect">Get Free Quote</NavLink>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default AboutCompany;